import React, { useState, useEffect } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from "reactstrap";
import api from "../../utils/Api";

const ProductSlider = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [imageItem, setImageItem] = useState([]);

  useEffect(() => {
    getEditPictures();
  }, []);

  // Getting iamges
  const getEditPictures = async () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get(
        "inventory/image/fetch?inventory_id=" + props.inventoryId,
        {
          headers: headers,
        }
      );
      if (response.status == 200) {
        setImageItem(response.data.data);
      }
    } catch (error) {
      console.log("Error in get edit pictures", error);
    }
  };

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === imageItem.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? imageItem.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = imageItem.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.attachment_url}
      >
        <img src={item.attachment_url} />
      </CarouselItem>
    );
  });

  return (
    <Carousel activeIndex={activeIndex} next={next} previous={previous}>
      <CarouselIndicators
        items={imageItem}
        activeIndex={activeIndex}
        onClickHandler={goToIndex}
      />
      {slides}
      <CarouselControl
        direction="prev"
        directionText="Previous"
        onClickHandler={previous}
      />
      <CarouselControl
        direction="next"
        directionText="Next"
        onClickHandler={next}
      />
    </Carousel>
  );
};

export default ProductSlider;
